import React from 'react'
import PropTypes from 'prop-types'
import Carousel from 'react-multi-carousel'
import { useGlobalData } from '../../context/globalDataContxt';
import NoveltyCard from '../NoveltyCard/NoveltyCard';
import './NoveltiesCarousel.scss'

const NoveltiesCarousel = ({ title, novelties }) => {

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1366 },
      items: 3
    },
    desktop: {
      breakpoint: { max: 1366, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 764 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 764, min: 0 },
      items: 1
    }
  }

  const { noveltiesAll } = useGlobalData();
  
  // Creando Array de todas las noticias que se deben mostrar con sus respectivos campos
  let noveltyAll = novelties.reduce((acc, noveltie) => {
    for (const nov in noveltiesAll) {
      const novelty = noveltiesAll[nov]
      if (noveltie.novelty?.id === novelty.id) {
        acc.push(noveltyConstructor(novelty, noveltie.destacado));
      }
    }
    return acc;
  }, [])
  
  if (!novelties || novelties.length === 0 || noveltiesAll.length === 0) return null;

  return (
    noveltyAll.length && (
      <div className="novelties-carousel-container my-1">
        <div className="container mx-auto w-100 pb-4 pt-4 px-0">
          {title &&
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="mb-0 novelties-title">
                {title}
              </div>
            </div>
          }
          <div id="novelties-carousel" className="mx-n2">
            <Carousel responsive={responsive}>
              {noveltyAll.map((noveltie) => {
                return <NoveltyCard key={noveltie?.novelty.id} noveltie={noveltie} />
              })}
            </Carousel>
          </div>
        </div>
      </div>
    )
  )
}

// Construyendo estructura de las Noticias
const noveltyConstructor = (novelty, destacado = false) => {
  return ({
    id: novelty.id,
    destacado: destacado,
    novelty: {
      id: novelty.id,
      slug: novelty.slug,
      title: novelty.title,
      thumbnailName: novelty.thumbnailName,
      thumbnail: { url: novelty.thumbnail?.url },
      date: novelty.date,
      dateTo: novelty.dateTo,
      novelties_categories: novelty.novelties_categories?.map((categories) => categories.id),
      summary: novelty.summary
    }
  })
}

export default NoveltiesCarousel

NoveltiesCarousel.propTypes = {
  title: PropTypes.string,
  novelties: PropTypes.array.isRequired,
}